( function( app ) {
  const COMPONENT = {
    init: function() {
      const mq = window.matchMedia( '(min-width: 1024px)' );
      const cards = document.querySelectorAll( '.service-card' );

      if ( !cards.length ) return;

      cards.forEach( ( card ) => {
        const title = card.querySelector( '.featured-services__title' );
        const benefits = card.querySelector( '.featured-services__benefits' );

        if ( !title || !benefits ) return;

        const getDistance = () => {
          return benefits.scrollHeight + 20;
        };

        const onEnter = () => {
          if ( !mq.matches ) return;

          title.style.transform = `translateY(-${getDistance()}px)`;
        };

        const onLeave = () => {
          title.style.transform = '';
        };

        card.addEventListener( 'mouseenter', onEnter );
        card.addEventListener( 'mouseleave', onLeave );

        mq.addEventListener( 'change', ( e ) => {
          if ( !e.matches ) {
            title.style.transform = '';
          }
        } );
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'service-card', COMPONENT );
} )( app );
